export const getOrderStatus = (status) => {
  switch (status) {
    case 'created':
      return 'criado'
    case 'awaitingPayment':
      return 'aguardando pagamento'
    case 'paid':
      return 'pago'
    case 'awaitingShipping':
      return 'preparando pedido'
    case 'sent':
      return 'enviado para entrega'
    case 'delivered':
      return 'entregue'
    case 'canceled':
      return 'cancelado'
    case 'refunded':
      return 'reembolsado'
    default:
      return ''
  }
}

export const unmaskString = (maskedInput) => {
  return maskedInput.replace(/[^\d]/g, '')
}



// WEBPACK FOOTER //
// ./src/services/ShopHelpers.js